module.exports = __webpack_public_path__ + "img/right-left.e17fdc43.svg";